module.exports = __webpack_public_path__ + "static/preview-2-ab30c9445921e103b55dbda7bb3a3b70.png";